var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTabLinear = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x: 1.5,
  y: 16.37,
  width: 4.13,
  height: 4.13,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  x: 16.37,
  y: 1.5,
  width: 4.13,
  height: 4.13,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M5.388 16.612 16.612 5.388"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h22v22H0z"
}))));
export { SvgTabLinear as ReactComponent };
export default __webpack_public_path__ + "assets/images/tab-linear.svg";